const shape = {
  borderRadiusSmall: 4,
  borderRadius: 8,
  borderRadiusLarge: 12,
  borderRadiusXLarge: 16,
  borderRadiusCircular: 9999,
};

export default shape;
